export default {
  // Page title
  'page.title': '世界時計',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': '現地時間',
  'timezone.currentTime': '現在の時刻',
  'timezone.label': 'タイムゾーン',
  'timezone.title': '{{city}}のタイムゾーン',
  'timezone.localClockOffset': 'ローカル時計オフセット',
  'timezone.timeZone': 'タイムゾーン',
  'timezone.today': '今日',
  'timezone.hours': '時間',
  'timezone.standardTimeZone': '標準時間帯',
  'timezone.daylightSavingTimeZone': '夏時間帯',

  // City names (keeping English as standard)
  'city.newYork': 'ニューヨーク',
  'city.london': 'ロンドン',
  'city.paris': 'パリ',
  'city.tokyo': '東京',
  'city.sydney': 'シドニー',
  'city.dubai': 'ドバイ',
  'city.singapore': 'シンガポール',
  'city.hongKong': '香港',
  'city.shanghai': '上海',
  'city.beijing': '北京',
  'city.mumbai': 'ムンバイ',
  'city.moscow': 'モスクワ',
  'city.berlin': 'ベルリン',
  'city.losAngeles': 'ロサンゼルス',
  'city.chicago': 'シカゴ',
  'city.toronto': 'トロント',
  'city.vancouver': 'バンクーバー',
  'city.brasilia': 'ブラジリア',
  'city.buenosAires': 'ブエノスアイレス',
  'city.cairo': 'カイロ',
  'city.istanbul': 'イスタンブール',

  // How to use
  'howto.title': 'オンライン世界時計の使い方',
  'howto.step1': 'この世界時計ウェブサイトは、世界中のあらゆる都市の現在時刻と世界時間を表示します。タイムゾーン、世界時間差、国際時間を瞬時に確認できます。',
  'howto.step2': '世界時計ホームページには、現地時間と主要都市の複数の世界時計が表示されます。各世界時間帯には、正確な時刻、日付、タイムゾーンオフセット情報が表示されます。',
  'howto.step3': '世界時計リストの任意の都市名をクリックして、詳細なタイムゾーン情報を表示します。各世界時間ページには、その場所の包括的なタイムゾーンデータと現在時刻が提供されます。',
  'howto.step4': '世界時計検索を使用して、世界中の任意の都市の時間を見つけます。世界時間帯の確認、国際時間調整、グローバル時間管理のニーズに最適です。',

  // User reviews
  'reviews.title': 'ユーザーレビュー',
  'reviews.globalBusiness': '国際ビジネスに必須！異なるタイムゾーン間の会議時間を簡単に調整でき、非常に便利です。',
  'reviews.travelBlogger': '旅行計画に必須！目的地の現地時間を常に把握でき、時差ボケの混乱がありません。',
  'reviews.remoteTeam': 'リモートチームコラボレーションに完璧！異なる国の同僚がいつ働いているかを簡単に確認できます。',
  'reviews.internationalFamily': '海外の家族との連絡に最適！睡眠を妨げずに電話する最適な時間を常に把握できます。',
  'reviews.managerZhang': 'プロジェクトマネージャーとして、グローバルクライアントとの会議をより効果的にスケジュールできます。',

  // User names
  'user.globalBusiness': 'グローバルビジネス',
  'user.travelBlogger': 'トラベルブロガー',
  'user.remoteTeam': 'リモート開発者',
  'user.internationalFamily': '国際家族',
  'user.managerZhang': 'チャン部長',

  // Keywords
  'keywords.worldclock': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': '国別時間',
  'timeIn': '時刻',
  'cities': '都市',
  'available': '利用可能',
  'citiesIn': '都市',
  'viewDetails': '詳細を表示',
  'countryNotFound': '国が見つかりません',
  'backToWorldClock': '世界時計に戻る',
  'cityNotFound': '都市が見つかりません',
  'popularCitiesIn': '人気都市',
  'currentTime': '現在時刻',
};
